import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { LoadingTrackerEntry } from './LoadingTrackerEntry';
import { World } from '../world/World';
import { UiManagerService } from '../ui/ui-manager.service';

export class LoadingManager {
    public firstLoad = true;
    public onFinishedCallback: () => void;

    private world: World;
    private gltfLoader: GLTFLoader;
    private loadingTracker: LoadingTrackerEntry[] = [];

    constructor(world: World, private uiManagerService: UiManagerService) {
        this.world = world;
        this.gltfLoader = new GLTFLoader();

        this.world.setTimeScale(0);
        this.uiManagerService.displayLoadingScreen(true);
    }

    public loadGLTF(path: string, onLoadingFinished: (gltf: any) => void): void {
        const trackerEntry = this.addLoadingEntry(path);

        this.gltfLoader.load(path,
            (gltf) => {
                onLoadingFinished(gltf);
                this.doneLoading(trackerEntry);
            },
            (xhr) => {
                if (xhr.lengthComputable && xhr.loaded) {
                    trackerEntry.progress = xhr.loaded / xhr.total;
                    this.uiManagerService.updateProgress(Math.floor(trackerEntry.progress * 100));
                }
            },
            (error) => {
                console.log('failed to load', path);
                console.error(error);
            });
    }

    public loadAudio(path: string, onLoaded: (buffer: AudioBuffer) => void): void {
        const trackerEntry = this.addLoadingEntry(path);
        new THREE.AudioLoader().load(
            path,
            (buffer) => { onLoaded(buffer); this.doneLoading(trackerEntry); },
            undefined,
            (error) => { console.error('failed to load audio', path, error); this.doneLoading(trackerEntry); },
        );
    }

    public addLoadingEntry(path: string): LoadingTrackerEntry {
        const entry = new LoadingTrackerEntry(path);
        this.loadingTracker.push(entry);

        return entry;
    }

    public doneLoading(trackerEntry: LoadingTrackerEntry): void {
        trackerEntry.finished = true;
        trackerEntry.progress = 1;

        if (this.isLoadingDone()) {
            if (this.onFinishedCallback !== undefined) {
                this.onFinishedCallback();
            }
            this.uiManagerService.displayLoadingScreen(false);
        }
    }

    private getLoadingPercentage(): number {
        let done = true;
        let total = 0;
        let finished = 0;

        for (const item of this.loadingTracker) {
            total++;
            finished += item.progress;
            if (!item.finished) done = false;
        }

        return (finished / total) * 100;
    }

    private isLoadingDone(): boolean {
        for (const entry of this.loadingTracker) {
            if (!entry.finished) return false;
        }
        return true;
    }
}
